import React, {useState} from 'react';
import {Card, Container, Navbar, Button, Form} from "react-bootstrap";
import {Link, NavLink} from "react-router-dom";
import axios from "axios";
import {CSSTransition} from 'react-transition-group';



const Header = () => {
    const initial = {name: "", email: "", phone: ""}
    const [isOpen, setIsOpen] = useState(false)
    const [success, setSuccess] = useState(false)
    const [feedback, setFeedback] = useState(initial)


    const handleInput = (e) => {
        setFeedback({...feedback, [e.target.name]: e.target.value})
    }
    const handleSubmit = (e) => {
        e.preventDefault()
        axios.post('https://613af3f5110e000017a453df.mockapi.io/modal', feedback)
            .then(() => {
                setSuccess(true)
                setTimeout(() => {
                    setIsOpen(false)
                    setSuccess(false)
                    setFeedback(initial)
                }, 2000)
            })
    }
    const handleClose = () => {
        setIsOpen(false)
        setSuccess(false)
    }

    return (
        <Card bg={"secondary"}>
            <Container>
                <header className='d-flex justify-content-between align-items-center '>
                    <Link to='/'>
                        <img className='logo'
                             src="https://static.wikia.nocookie.net/logopedia/images/5/59/FoxSportsNews_logo_1.png"
                             alt=""/>
                    </Link>
                    <Navbar>
                        <NavLink exact className='nav-a' to='/'>Main</NavLink>
                        <NavLink className='nav-a' to='/news'>News</NavLink>
                        <NavLink className='nav-a' to='/signin'>Sign in</NavLink>
                        <NavLink className='nav-a' to='/register'>Register</NavLink>
                        <NavLink className='nav-a' to='/requests'>Requests</NavLink>
                        <NavLink className='nav-a' to='/students'>Students</NavLink>
                        <Button onClick={() => setIsOpen(true)} type="button" className='btn'
                                variant="success">Feedback</Button>
                    </Navbar>
                </header>
                <CSSTransition unmountOnExit in={isOpen} timeout={500} classNames="alert">
                    <div className="modal-window">
                        <div className='modal-content'>
                            {
                                success ? "You request send)" : <Form onSubmit={handleSubmit}>
                                    <Form.Group className="mb-3" controlId="exampleForm.ControlInput1">
                                        <Form.Label>Add name</Form.Label>
                                        <Form.Control value={feedback.name} name='name' onChange={handleInput} required
                                                      type="text" placeholder="name"/>
                                    </Form.Group>
                                    <Form.Group className="mb-3" controlId="exampleForm.ControlInput1">
                                        <Form.Label>Add email address</Form.Label>
                                        <Form.Control value={feedback.email} name='email' onChange={handleInput}
                                                      required type="email" placeholder="name@example.com"/>
                                    </Form.Group>
                                    <Form.Group className="mb-3" controlId="exampleForm.ControlTextarea1">
                                        <Form.Label>Add phone number</Form.Label>
                                        <Form.Control value={feedback.phone} name='phone' onChange={handleInput}
                                                      required type="text" placeholder='phone'/>
                                    </Form.Group>
                                    <Button type="submit" className='btn w-100' variant="success">Send</Button>
                                </Form>
                            }
                            <div onClick={handleClose} className='close-modal position-absolute'>❌</div>
                        </div>
                    </div>
                </CSSTransition>
            </Container>
        </Card>

    );
};

export default Header;